import type { MessageDescriptor } from 'react-intl';
import type { DirectedCastPictureFailReason } from 'fym-shared/src/music24/directedVideoApi';
import { castMessages as messages } from '../messages/castMessages';

/**
 * The sentence of a failed cast picture by its reason (owner report 2026-10-20). An API from before
 * the reasons sends none: then the old general sentence. Pure.
 */
export function failedPictureMessage(reason: DirectedCastPictureFailReason | undefined): MessageDescriptor {
  switch (reason) {
    case 'refused':
      return messages.pictureFailedRefused;
    case 'error':
      return messages.pictureFailedError;
    case 'quota':
      return messages.pictureFailedQuota;
    case undefined:
      return messages.pictureFailed;
  }
}
